module.exports = __webpack_public_path__ + "img/licenseQR.7d17efcf.png";